import API from "./../common/api";
import Fetch from "./fetch";

class Culture {
    static getCountries() {
        const url = `${API.PREFIX}${API.LOCALE.ROOT}`;
        return Fetch.get(url);
    }

    static getLanguages(countryCode) {
        const url =`${API.PREFIX}${API.LOCALE.ROOT}
            ${API.LOCALE.LOCALE_BY_COUNTRY.replace(API.KEYS.COUNTRY_CODE, countryCode)}`;
        return Fetch.get(url);
    }

    static getAllLanguages() {
        const url =`${API.PREFIX}${API.LOCALE.ALL_LANGUAGES}`;
        return Fetch.get(url);
    }
}

export default Culture;